export const PageConsultaVagas = {
    title: 'Consulta Vagas',
    url: '/consulta-vagas'
}